export default __webpack_public_path__ + "images/1b1b7bbf5d1730549a51767cae98eba5-close.svg";